import {useState, useCallback} from 'react'
import {message} from 'antd'
import parseToken from "../../../../helpers/parseToken"
import {formatDate3} from "../../../../helpers/formatDate"

const useExport = (exportApiFunction, options = {}) => {
    const [loading, setLoading] = useState(false)

    const {
        needsLevel = true,
        needsTenantName = true,
        fileName = 'export.xlsx',
        onSuccess,
        onError
    } = options

    const handleExport = useCallback(async (filters, tenants, level, customPayload = {}) => {
        setLoading(true)

        try {
            const decodeToken = parseToken()
            let _tenantName = ''

            if (needsTenantName && tenants?.length > 0 && filters?.tenantId) {
                const tenantIdArray = Array.isArray(filters.tenantId)
                    ? filters.tenantId
                    : [filters.tenantId]

                const itemTenant = tenants.find(item =>
                    tenantIdArray.includes(item.value) ||
                    tenantIdArray.includes(item.value + '')
                )

                if (itemTenant) {
                    _tenantName = itemTenant.label
                }
            }

            const payload = {
                tenantId: Array.isArray(filters.tenantId)
                    ? filters.tenantId.join(',')
                    : filters.tenantId,
                fromDate: `${formatDate3(filters.fromDate)} 00:00:00`,
                toDate: `${formatDate3(filters.toDate)} 23:59:00`,
                userName: decodeToken.sub,
                pagesize: null,
                page: null,
                ...customPayload
            }

            if (needsLevel) {
                payload.level = level
            }
            if (needsTenantName && _tenantName) {
                payload.tenantName = _tenantName
            }

            delete payload.page
            delete payload.limit

            const response = await exportApiFunction(payload)
            const {data} = response

            const now = new Date()
            const timestamp = [
                now.getFullYear(),
                String(now.getMonth() + 1).padStart(2, '0'),
                String(now.getDate()).padStart(2, '0'),
                String(now.getHours()).padStart(2, '0'),
                String(now.getMinutes()).padStart(2, '0'),
                String(now.getSeconds()).padStart(2, '0'),
            ].join('')

            const ext = fileName.includes('.') ? fileName.substring(fileName.lastIndexOf('.')) : ''
            const baseName = fileName.includes('.') ? fileName.substring(0, fileName.lastIndexOf('.')) : fileName
            const tenantPrefix = _tenantName ? `${_tenantName}_` : ''
            const dynamicFileName = `${tenantPrefix}${baseName}_${timestamp}${ext}`

            downloadFile(data, dynamicFileName)

            message.success('Export thành công!')

            if (typeof onSuccess === 'function') {
                onSuccess(data)
            }
        } catch (e) {
            const errorMessage = e.message || 'Export thất bại!'
            message.error(errorMessage)

            if (typeof onError === 'function') {
                onError(e)
            }
        } finally {
            setLoading(false)
        }
    }, [exportApiFunction, needsLevel, needsTenantName, fileName, onSuccess, onError])

    return {loading, handleExport}
}

const downloadFile = (data, filename) => {
    try {
        const href = URL.createObjectURL(data)
        const link = document.createElement('a')

        link.href = href
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        URL.revokeObjectURL(href)
    } catch (error) {
        message.error('Download error:', error)
        throw new Error('Không thể tải file')
    }
}

export default useExport